import React from 'react';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const CommunityPreview = () => {
  const benefits = [
    {
      icon: (
        <svg className="w-8 h-8 text-sage-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "Monthly Workout Programs",
      description: "Tailored fitness programs for busy mums, corporate women, glute-focused workouts, and gentle movement sessions"
    },
    {
      icon: (
        <svg className="w-8 h-8 text-sage-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      title: "New Recipes Monthly",
      description: "15+ fresh allergy-friendly recipes each month with seasonal menus, quick meals, and batch cooking guides"
    },
    {
      icon: (
        <svg className="w-8 h-8 text-sage-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      title: "Eczema & Wellness Support",
      description: "Expert tips for managing eczema flares, stress-relief techniques, and personalized wellness guidance"
    },
    {
      icon: (
        <svg className="w-8 h-8 text-sage-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
        </svg>
      ),
      title: "Community Forum",
      description: "Connect with others who truly understand your journey. Share experiences, get support, and find encouragement from women facing similar challenges"
    }
  ];

  return (
    <section id="community-preview" className="relative py-12" style={{ backgroundColor: '#F5EBDD' }}>
      {/* Organic top curve */}
      <div className="absolute top-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-24" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0 C300,80 900,80 1200,0 L1200,120 L0,120 Z" fill="#ffffff"></path>
        </svg>
      </div>

      <div className="relative pt-24 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
          </motion.div>


          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h3 className="text-3xl md:text-4xl font-playfair font-bold text-charcoal-900 mb-4">
              Ready to get started? Let's go!
            </h3>
            <p className="text-lg text-charcoal-600 mb-8 max-w-2xl mx-auto font-nunito">
              Join a supportive community of women on the same journey as you. Get instant access to helpful resources and connect with others who truly understand.
            </p>
            <RouterLink to="/login">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                style={{ backgroundColor: '#d9a79c' }}
                className="text-white px-12 py-4 rounded-full text-lg font-medium hover:opacity-90 transition-all duration-200 shadow-soft hover:shadow-soft-lg"
              >
                Join Alera Community
              </motion.button>
            </RouterLink>
            <p className="text-sm text-charcoal-500 mt-4 font-nunito">
              Flexible monthly or annual plans available
            </p>
          </motion.div>
        </div>
      </div>

      {/* Organic bottom curve */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-24" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,120 C300,40 900,40 1200,120 L1200,0 L0,0 Z" fill="#ffffff"></path>
        </svg>
      </div>
    </section>
  );
};

export default CommunityPreview;
